import gql from 'graphql-tag'

export default gql`
  query GetCart($id: UUID) {
    cart(id: $id) {
      ... on Cart {
        id
        cartAmount
        shippingCost
        currency
        items {
          id
          productId
          sku
          salesPrice
          category
          name
          image {
            url
            description
          }
          ... on GenericCartItem {
            quantity
            description
            options {
              name
              id
              value
            }
          }
          ... on GiftCardCartItem {
            value
            recipientDetails {
              recipientName
              message
              ... on VirtualRecipientDetails {
                recipientEmail
                senderName
                deliveryDate
                deliveryMethod
              }
            }
          }
        }
        marketplaceItems {
          id
          sku
          variantGroupCode
          brand
          category {
            path {
              code
              title
            }
          }
          shop {
            retailer {
              sys {
                id
              }
              slug
            }
            id
            name
          }
          name
          listPrice
          discountPrice
          quantity
          promotions {
            campaignId
            title
          }
          image {
            url
            description
          }
          optionValues {
            id
            optionId
            displayName
            value
          }
          variant {
            quantity
            returnable
            promotions {
              campaignId
              title
            }
          }
          issues {
            type
            severity
          }
        }
        coupons {
          __typename
          ... on MarketplaceCouponInvalid {
            code
            errorCode
          }
          ... on MarketplaceCouponExpired {
            campaignId
            code
            errorCode
          }
          ... on MarketplaceCouponEligible {
            campaignId
            code
          }
          ... on MarketplaceCouponIneligible {
            campaignId
            code
            message
          }
        }
      }
      ... on Error {
        message
      }
    }
    marketplaceShippingConfiguration {
      shippingCost
    }
  }
`
